<template>
    <b-row class="m-0 mt-4">
        <b-col>
            <b-breadcrumb>
                <b-breadcrumb-item :to="{ name: 'dashboard' }">
                    <b-icon icon="house-fill" /><span class="ml-2">Главная</span>
                </b-breadcrumb-item>
                <b-breadcrumb-item v-for="route in getRoutes"
                                   :to="{ name: route.meta.bcName, param: route.params }"
                                   :text="route.meta.title" :disabled="route.meta.bcDisabled">
                </b-breadcrumb-item>
            </b-breadcrumb>
        </b-col>
    </b-row>
</template>

<script>
    // import {mapGetters} from "vuex";

    export default {
        name: "SubTopNavbar",
        computed: {
            getRoutes() {
                let routes = [];
                for (const i in this.$route.matched) {
                    let route = this.$route.matched[i];
                    if (route.meta.hasOwnProperty('bcName')) {
                        routes.push(route);
                    }
                }
                return routes;
            }
        },
        methods: {
        }
    }
</script>

<style scoped lang="scss">

</style>